import Vue from 'vue'

export default {
  info: function (params) {
    return Vue.http.get(Vue.prototype.serverUrl + 'deposit/info', {
      params: params
    })
  },
  create: function (params) {
    return Vue.http.get(Vue.prototype.serverUrl + 'deposit/create', {
      params: params
    })
  },
  info1: function (params) {
    return Vue.http.get(Vue.prototype.serverUrl + 'deposit/info1', {
      params: params
    })
  },
  create1: function (params) {
    return Vue.http.get(Vue.prototype.serverUrl + 'deposit/create1', {
      params: params
    })
  },
  c2c: function (params) {
    return Vue.http.get(Vue.prototype.serverUrl + 'deposit/c2c', {
      params: params
    })
  },
  ip: () => Vue.http.get(`${Vue.prototype.serverUrl}deposit/ip`),
  qrcode: params => Vue.http.get(`${Vue.prototype.serverUrl}deposit/qrcode`, { params })
}



// WEBPACK FOOTER //
// ./src/models/models/Deposit.js